export default "/images/ac1e71a811f805735712db8dc2a3a8a8.png";